import {useEffect, useState} from "react";
import SimpleSelect from "./controls/SimpleSelect";
import {getConfig, getEnv} from "../lib/configMgr";
import NumericInput from "./controls/NumericInput";
import Checkbox from "./controls/Checkbox";
import _ from "lodash";
import {extractVersion} from "./modelVersion";

const DEFAULT_MODEL = "default";


export const ChatSettings = ({onChange = (s) => {}, categories = [], userStore, appStatusStore, disabled=false}) => {

  const {isAdmin} = userStore;
  const {aiModels = {}} = appStatusStore;
  const availableModels = Object.entries({[DEFAULT_MODEL]: "default", ...aiModels});

  const [useTemperature, setUseTemperature] = useState(true);
  const [temperature, setTemperature] = useState(0.1);
  const [topP, setTopP] = useState(0.9);
  const [topK, setTopK] = useState(null);
  const [stream, setStream] = useState(getEnv() === "dev");
  const [model, setModel] = useState(DEFAULT_MODEL);

  useEffect(() => {
    onChange({
      ...(model !== DEFAULT_MODEL ? {model} : {}),
      stream,
      top_k: topK,
      // Use T or P, not both
      ...(useTemperature ? {temperature} : {top_p: topP}),
    });
  }, [model, stream, topK, useTemperature, temperature, topP])

  return (
    <div className={"chat-settings"}>
      <div className={"vertical"}>
        {isAdmin && (
          <>
            <span className={"admin"}>
              Model&nbsp;
              <select
                onChange={(e) => setModel(e.target.value)}
                defaultValue={model}
                disabled={disabled}
                key={"model-changer"}
                title={"Choose the LLM model"}
              >
                {availableModels
                  .sort(([aid, aname], [bid, bname]) => {
                    const aMatch = /^(US|Global)/.test(aname);
                    const bMatch = /^(US|Global)/.test(bname);
                    if (aMatch && !bMatch) return -1;
                    if (bMatch && !aMatch) return 1;
                    return aname.toLocaleLowerCase().localeCompare(bname.toLocaleLowerCase());
                  })
                  .map(([modelId, modelName]) => (
                    <option key={modelId} value={modelId} title={modelId}>{`${modelName}${extractVersion(modelId)}`}</option>
                  ))}
              </select>
            </span>
            <div key={"model-settings"} className="admin model-settings">
              <div className={"temp-p"} >
                <SimpleSelect
                  disabled={disabled}
                  title={useTemperature
                         ? "Randomness (affects conservative vs. creative)"
                         : "Option probability threshold (affects diversity of outputs)"}
                  options={["T", "P"]}
                  onChange={v => setUseTemperature(v === "T")}
                />
                <NumericInput
                  disabled={disabled}
                  min={0} max={1} step={0.1} precision={2} value={useTemperature ? temperature : topP}
                  onChange={v => useTemperature ? setTemperature(v) : setTopP(v)}/>
              </div>
              <Checkbox
                disabled={disabled}
                label={"K"}
                title={"Sample top K options (remove long tails of low-probability responses)"}
                checked={topK != null}
                onChange={v => setTopK(v ? 500 : null)}
              >
                <NumericInput
                  disabled={disabled || topK === null}
                  min={0} max={500} step={5} precision={0} value={topK}
                  onChange={v => setTopK(v)}/>
              </Checkbox>
            </div>
          </>
        )}
      </div>
    </div>
  )
};
